import type { LineMarkViewModel } from "./types-gantt";

export function LineMarkView({
  className,
  labelClassName,
  ruleClassName,
  style,
  tone,
  dataPast,
  testId,
  label,
  rest,
}: LineMarkViewModel) {
  return (
    <div
      className={className}
      style={style}
      data-tone={tone}
      data-past={dataPast}
      data-testid={testId}
      {...rest}
    >
      {label ? <span className={labelClassName}>{label}</span> : null}
      <span className={ruleClassName} />
    </div>
  );
}
